import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import { preventCopy, preventContextMenu } from '../../utils/preventCopyPaste';

declare global {
	interface Window {
		dataLayer: any[];
		gtag: (...args: any[]) => void;
	}
}

const AppRoute = () => {
	useEffect(() => {
		// const rootElement = document.getElementById('root');
		// if (rootElement) {
		// 	rootElement.addEventListener('copy', preventCopy);
		// 	rootElement.addEventListener('contextmenu', preventContextMenu);
		// 	rootElement.style.userSelect = 'none';
		// }

		if (process.env.REACT_APP_ENV === 'production') {
			
			if (!document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`)) {
				const script = document.createElement('script');
				script.async = true;
				script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GA_ID}`;
				document.head.appendChild(script);
			}

			if (!document.querySelector('script[data-ga-init="true"]')) {
				const inlineScript = document.createElement('script');
				inlineScript.setAttribute('data-ga-init', 'true');
				inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${process.env.REACT_APP_GA_ID}');
    `;
				document.head.appendChild(inlineScript);
			}
		} else {
			console.log('Skipping Google Analytics — environment:', process.env.REACT_APP_ENV);
		}

		return () => {
			// if (rootElement) {
			// 	rootElement.removeEventListener('copy', preventCopy);
			// 	rootElement.removeEventListener('contextmenu', preventContextMenu);
			// 	rootElement.style.userSelect = '';
			// }
		};
	}, []);

	return (
		<BrowserRouter>
			<Routes>
				<Route path='/*' element={<PrivateRoute />} />
			</Routes>
		</BrowserRouter>
	);
};

export default AppRoute;
